/** Consulta na SEFAZ (distribuição DF-e por chave) o XML de uma NF-e destinada à empresa alvo. */
export class ConsultaChaveNFeRequest {
  /** Chave de acesso da NF-e (44 dígitos, sem máscara). */
  chaveAcesso = '';
  /** Empresa destinatária que consulta a SEFAZ: a do token ou uma do grupo, quando o token é da matriz. */
  idEmpresaAlvo: number;
}
